export const convertRgbToRGBA = (rgb: string, opacity = 0.1): string => {
  const rgbaRegex = /rgba?\((\d+), (\d+), (\d+)(?:, (\d*\.?\d+))?\)/
  const match = rgb.match(rgbaRegex)

  if (match) {
    const r = match[1]
    const g = match[2]
    const b = match[3]

    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  }

  return rgb
}

export const convertHexToRGB = (hex: string): string => {
  let r: number, g: number, b: number
  hex = hex.replace(/^#/, '')

  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16)
    g = parseInt(hex[1] + hex[1], 16)
    b = parseInt(hex[2] + hex[2], 16)
  } else {
    r = parseInt(hex.slice(0, 2), 16)
    g = parseInt(hex.slice(2, 4), 16)
    b = parseInt(hex.slice(4, 6), 16)
  }

  return `rgb(${r}, ${g}, ${b})`
}

export const isHexColor = (color: string): boolean => {
  const hexRegex = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i

  return hexRegex.test(color)
}

export const convertRgbToHex = (rgb: string): string => {
  const rgbaRegex = /rgba?\((\d+), (\d+), (\d+)(?:, (\d*\.?\d+))?\)/
  const match = rgb.match(rgbaRegex)

  if (!match) {
    throw new Error('Invalid RGB or RGBA string')
  }

  const r = parseInt(match[1], 10)
  const g = parseInt(match[2], 10)
  const b = parseInt(match[3], 10)

  const toHex = (component: number): string => {
    const hex = component.toString(16)

    return hex.length === 1 ? '0' + hex : hex
  }

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

export const convertRgbOrRgbaToHex = (color: string, bgColor = '#FFFFFF'): string => {
  if (!color) {
    return ''
  }
  // Regex to extract values from RGB or RGBA format
  const rgbaRegex = /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/
  const match = color.match(rgbaRegex)
  if (!match) {
    throw new Error('Invalid RGB or RGBA format. Expected format: rgb(R, G, B) or rgba(R, G, B, A)')
  }
  // Extract RGB values
  const r = parseInt(match[1], 10)
  const g = parseInt(match[2], 10)
  const b = parseInt(match[3], 10)
  const a = match[4] !== undefined ? parseFloat(match[4]) : 1 // Default alpha to 1 if not present
  if (a < 0 || a > 1) {
    throw new Error('Alpha must be between 0 and 1')
  }
  // Helper function to convert a number to a two-digit hex string (without padStart)
  const toHex = (component: number): string => {
    const hex = component.toString(16).toUpperCase()
    return hex.length === 1 ? `0${hex}` : hex // Manual padding if necessary
  }
  // If alpha is 1, return the solid RGB hex color
  if (a === 1) {
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`
  }
  // Convert background color from HEX to RGB
  const bgR = parseInt(bgColor.substring(1, 3), 16)
  const bgG = parseInt(bgColor.substring(3, 5), 16)
  const bgB = parseInt(bgColor.substring(5, 7), 16)
  // Blend the RGBA color with the background color
  const blendedR = Math.round((1 - a) * bgR + a * r)
  const blendedG = Math.round((1 - a) * bgG + a * g)
  const blendedB = Math.round((1 - a) * bgB + a * b)
  // Return the final blended HEX color
  return `#${toHex(blendedR)}${toHex(blendedG)}${toHex(blendedB)}`
}
